import React, { useState } from "react";
import axios from "axios";
import { useContext } from "react";
import RegistrationContext from "../contexts/RegistrationContext";
import { base_url } from "../config";
import RegistrationNotice from "../components/RegistrationNotice/RegistrationNotice";

function ForgotPass() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const {
    setScreen,
    setAuthenticated,
    setError,
    setStatus,
    reload,
    setReload,
  } = useContext(RegistrationContext);
  const handleSubmitEmail = async (event) => {
    event.preventDefault();

    // Reset login error state
    setError("");

    try {
      await axios.post(`${base_url}/api/forgot-password`, {
        email: email,
      });
      setCodeSent(true);
      setStatus("We have sent you a verification code to your email address");
    } catch (error) {
      setError("Password reset failed. Email not found");
    }
  };

  const handleSubmitCode = async (event) => {
    event.preventDefault();

    setError("");

    try {
      // Make a POST request to your authentication endpoint
      const response = await axios.post(
        `${base_url}/api/forgot-password-code`,
        {
          email,
          code,
        }
      );
      setAuthenticated(true);
      localStorage.setItem("token", response.data.access_token);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.data.access_token}`;
      setReload(reload + 1);
      setStatus("");
    } catch (error) {
      setStatus("");
      setError("Incorrect code: " + error.response.data.message);
    }
  };


  return (
    <main className="flex-1">
      <div className="container mx-auto px-4">
        {/* Welcome Message */}
        <div className="text-center py-8">
          <h2 className="text-2xl font-medium text-gray-800">Welcome to the IJCAI-ECAI 2026 registration system</h2>
        </div>

        {/* Login Form */}
        <div className="max-w-3xl mx-auto py-8">

          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={!codeSent ? handleSubmitEmail : handleSubmitCode} className="flex flex-col gap-6">
            <h2 className="text-2xl font-bold text-gray-800">Login with Email & Code</h2>
              <div className="flex flex-col md:flex-row items-center gap-4">
                <label
                  htmlFor="email"
                  className="md:w-40 text-right md:text-left font-medium text-gray-700"
                >
                  E-Mail Address
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  disabled={codeSent ? true : false}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={`w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${codeSent ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""
                    }`}
                  placeholder="your@email.com"
                />
              </div>

              {codeSent ? (
                <div className="flex flex-col md:flex-row items-center gap-4">
                  <label
                    htmlFor="code"
                    className="md:w-40 text-right md:text-left font-medium text-gray-700"
                  >
                    Code
                  </label>
                  <input
                    type="text"
                    id="code"
                    className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    required
                  />
                </div>
              ) : (<div className="flex flex-col md:flex-row items-center mb-10" />)}
              <div className="flex flex-wrap items-center gap-4">

                <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors" type="submit">
                  {!codeSent ? "Email access code" : "Login"}
                </button>
                <a href="#" onClick={() => setScreen("login")} className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors">
                  Use password login
                </a>
              </div>


            </form>
          </div>

        </div>

        <RegistrationNotice />
      </div>
    </main>

  );
  
}

export default ForgotPass;
